var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seen)?_c('img',{style:(_vm.style),attrs:{"src":_vm.src}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }